import React, { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";
import type { SentimentTrendPoint } from "@models/sentiment";
import { SENTIMENT_EMOJI } from "@models/sentiment";

const WEEKDAY_INITIALS = ["S", "M", "T", "W", "T", "F", "S"];

export interface WeeklySentimentBarProps {
  days: SentimentTrendPoint[];
}

const WeeklySentimentBar: FC<WeeklySentimentBarProps> = ({ days }) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      {days.map((day) => {
        const date = new Date(`${day.date}T12:00:00`);
        const emoji = day.sentiment ? SENTIMENT_EMOJI[day.sentiment] : null;
        const isToday = day.date === new Date().toISOString().slice(0, 10);

        return (
          <Stack key={day.date} alignItems="center" spacing={0.5}>
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18,
                bgcolor: day.sessionCount > 0 ? "action.selected" : "action.hover",
                border: isToday ? 2 : 0,
                borderColor: "primary.main",
                boxSizing: "border-box",
              }}
            >
              {emoji ?? ""}
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: 12 }}>
              {WEEKDAY_INITIALS[date.getDay()]}
            </Typography>
          </Stack>
        );
      })}
    </Stack>
  );
};

export default WeeklySentimentBar;
